<div class="wm-l-account-activated">
  <div class="wm-l-account-activated-text" >Your account has been activated.</div>
  <div class="wm-l-account-activated-button"><button pButton (click)="goToSignIn()" >Proceed</button></div>
</div>
